import { heroData } from '@/mocks/homeData';

export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/40"></div>

      <div className="absolute top-0 right-0 w-[55%] h-full hidden md:block">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20featuring%20vibrant%20warm%20coral%20and%20orange%20gradients%20with%20flowing%20geometric%20shapes%20representing%20digital%20entertainment%20and%20social%20media%20trends%2C%20soft%20glowing%20particles%20floating%20in%20the%20background%2C%20modern%20minimalist%20aesthetic%20with%20depth%20and%20movement%2C%20editorial%20quality%20with%20cinematic%20lighting%2C%20dark%20warm%20tones%20creating%20contrast%2C%20smooth%20flowing%20lines%20suggesting%20connectivity%20and%20real-time%20updates%2C%20professional%20digital%20art%20style%20with%20rich%20texture%20and%20atmospheric%20depth&width=1000&height=900&seq=hero-main-visual&orientation=landscape"
          alt="51吃瓜app每日大赛在线观看与视频吃瓜平台主视觉"
          className="w-full h-full object-cover object-top opacity-90"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-transparent via-background-50/50 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="md:w-[52%] lg:w-[48%]">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/70 border border-accent-200/50 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
              <span className="text-xs font-medium text-accent-700 whitespace-nowrap">{heroData.tag}</span>
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-4">
              51吃瓜app——每日大赛在线观看，畅享视频吃瓜体验
            </h1>

            <p className="text-base md:text-lg text-accent-600 font-medium mb-4">
              {heroData.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg">
              {heroData.intro}
            </p>

            <div className="flex flex-wrap items-center gap-5 md:gap-8 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="flex items-baseline gap-1.5">
                  <span className="text-xl md:text-2xl font-bold text-foreground-950 whitespace-nowrap">{stat.value}</span>
                  <span className="text-xs md:text-sm text-foreground-500 whitespace-nowrap">{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
              <a
                href="#media"
                onClick={(e) => handleScrollTo(e, 'media')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-full cursor-pointer whitespace-nowrap transition-all hover:bg-primary-600 active:scale-95"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观看热门视频
              </a>
              <a
                href="#app"
                onClick={(e) => handleScrollTo(e, 'app')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 border border-background-300 text-foreground-700 text-sm font-semibold rounded-full cursor-pointer whitespace-nowrap transition-all hover:bg-background-100 hover:border-primary-300 hover:text-primary-600 active:scale-95"
              >
                <i className="ri-download-line text-lg"></i>
                下载客户端
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}